/**
 * Data kalendarzowa YYYY-MM-DD w strefie lokalnej przeglądarki (bez UTC z toISOString).
 * @param {Date} [d]
 * @returns {string}
 */
export function formatLocalYmd(d = new Date()) {
  const x = d instanceof Date ? d : new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, '0');
  const day = String(x.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Moment zakończenia wydarzenia (data + start + duration), jak w HistoryView.
 * @param {object} event
 * @returns {Date | null}
 */
export function getEventEndDate(event) {
  if (!event?.event_date) return null;
  const date = String(event.event_date).trim();
  let rawTime = event.start_time != null ? String(event.start_time).trim() : '';
  if (rawTime.includes('T')) {
    rawTime = rawTime.split('T').pop() || '';
  }
  const timePart =
    rawTime.length === 5 && rawTime.includes(':') && rawTime.split(':').length === 2
      ? `${rawTime}:00`
      : rawTime || '00:00:00';
  const start = new Date(`${date}T${timePart}`);
  if (!Number.isFinite(start.getTime())) return null;
  const end = new Date(start);
  const dm = Number(event.duration_minutes);
  if (Number.isFinite(dm) && dm > 0) {
    end.setMinutes(end.getMinutes() + dm);
  }
  return end;
}

/**
 * Wydarzenie jeszcze trwa lub jest w przyszłości (koniec > teraz). Anuluowane → false.
 * Przy braku możliwości obliczenia końca — fallback: data kalendarzowa >= dziś (lokalnie).
 * @param {object} event
 * @param {Date} [now]
 * @returns {boolean}
 */
export function isEventNotFinishedYet(event, now = new Date()) {
  if (!event || event.is_cancelled === true) return false;
  const end = getEventEndDate(event);
  if (!end || !Number.isFinite(end.getTime())) {
    return String(event.event_date || '') >= formatLocalYmd(now);
  }
  return end.getTime() > now.getTime();
}
